import { add } from 'date-fns/add';
import { endOfDay } from 'date-fns/endOfDay';
import { endOfMonth } from 'date-fns/endOfMonth';
import { isAfter } from 'date-fns/isAfter';
import { startOfMonth } from 'date-fns/startOfMonth';
import { getCompanyStartOfWeek, getDate, getStringFromDate } from './dates.js';
// Utility functions
/**
 * If you pass in a `string` as the input, the function will return a string.
 * If you pass in a `Date` as the input, the function will return a `Date`.
 */
const parseReturnValue = (input, output) => {
    if (typeof input === 'string') {
        return getStringFromDate(output, { ISO8601DateExtended: true });
    }
    return output;
};
/**
 * There are four timesheet durations:
 * - 1 day (val: 1)
 * - 1 week (val: 7)
 * - 2 weeks (val: 14)
 * - 1st and 16th of a month (val: 15)
 *
 * This function handles the 1st of the month and 16th of a month duration (val: 15).
 *
 * The implementation checks for < 15th of the month and >= 15th of the month
 * and returns either the 1st to 15th or 16th to end of the month.
 */
export function getMonthRemainingHalf(date) {
    const value = getDate(date);
    const today = value.getDate();
    const monthStart = startOfMonth(value);
    if (today <= 15) {
        return {
            startDate: parseReturnValue(date, monthStart),
            endDate: parseReturnValue(date, endOfDay(add(monthStart, { days: 14 }))),
        };
    }
    const monthEnd = endOfMonth(value);
    return {
        startDate: parseReturnValue(date, add(monthStart, { days: 15 })),
        endDate: parseReturnValue(date, monthEnd),
    };
}
export function getStartOfWeek(weekStart, date) {
    const value = getDate(date);
    const endOfDate = endOfDay(value);
    const result = getCompanyStartOfWeek(value, weekStart);
    if (isAfter(result, endOfDate)) {
        return parseReturnValue(date, add(result, { days: -7 }));
    }
    return parseReturnValue(date, result);
}
export function getEndDate(length, date) {
    const value = getDate(date);
    return parseReturnValue(date, endOfDay(add(value, { days: length - 1 })));
}
export function getTimesheetEndDate(timesheetDuration, startDate) {
    if (timesheetDuration === 15) {
        const { endDate } = getMonthRemainingHalf(startDate);
        return endDate;
    }
    return getEndDate(timesheetDuration, startDate);
}
export function getTimesheetPeriod(timesheetDuration, weekStart, referenceDate = new Date()) {
    const refDateString = typeof referenceDate === 'string'
        ? referenceDate
        : getStringFromDate(referenceDate, {
            ISO8601DateExtended: true,
        });
    if (timesheetDuration === 15) {
        return getMonthRemainingHalf(refDateString);
    }
    const startDate = timesheetDuration === 1
        ? refDateString
        : getStartOfWeek(weekStart, refDateString);
    return {
        startDate,
        endDate: getEndDate(timesheetDuration, startDate),
    };
}
//# sourceMappingURL=timesheet-period.js.map